import React, { useEffect, useState } from 'react';
import axios from "axios";
import ReactDOMServer from 'react-dom/server';
import { AppRemixIcon, AppSingleSelect } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../routing/helpers/router';
import useIsMounted from '../../../../components/hooks/useIsMounted';

const Report15Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;
  const isMounted = useIsMounted();
  const [reportOptions, setReportOptions] = useState();

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 15,
      })
      .then((r) => {
        if (isMounted.current) {
          setReportOptions(r.data);
        }
      })
      .catch(() => "");
  }, []);
  // < LOAD REPORT OPTIONS //

  if (!reportOptions) return <></>;

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <AppSingleSelect
            icon={<AppRemixIcon icon="folder-2" />}
            options={reportOptions?.folders || []}
            title={<Translator file="module" name="module.folder" />}
            placeholder={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="select.an.option" />
            )}
            value={values.r15plantGroup}
            onChange={(e) => handleOnSetFieldValue('r15plantGroup', e)}
            hasSearchBox
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={
                  !values.r15plantGroup || values.r15plantGroup.length === 0
                }
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report15Options;
